import { myInsifyLinkRegex } from '~globals';

type UseMyInsifyUrlReturn = {
  formatMyInsifyLink: (link: string) => string;
};

/**
 * Hook to format My Insify URLs - Previously used for migrating device_id across domains
 * Keeping for future use if the need arises
 * @returns {Function} formatMyInsifyLink - Function to format My Insify URLs
 */
export const useMyInsifyUrl = (): UseMyInsifyUrlReturn => {
  const formatMyInsifyLink = (link: string): string => {
    try {
      if (myInsifyLinkRegex.test(link)) {
        const url = new URL(link);
        return url.toString();
      } else {
        return link;
      }
    } catch (err) {
      return link;
    }
  };

  return { formatMyInsifyLink };
};
